import { TimeFormat } from '@instinet-analytics/core-lib';
import {
    formatResponseTime,
    strikeTimeToString,
} from 'widgets/estimatedTradeCost/store/data/mapping';
import { StrikeBenchmark } from 'widgets/estimatedTradeCost/components/options';
import { extractErrorMessage } from 'widgets/estimatedTradeCost/store/data/EstimateTradeCostDataState';
import { EstimatedTradeCostComparisonData } from 'widgets/estimatedTradeCost/widget-comparison/estimatedTradeCostComparisonData';

export type EstimatedTradeCostGridRow = {
    uid: string;
    benchmark: string;
    profile: string;
    minPartLit: number;
    maxPartLit: number;
    status: 'In Progress' | 'Completed' | 'Failed';
    error?: unknown;
    totalCost?: number;
    totalRisk?: number;
    efPart?: number;
    startTime?: string;
    endTime?: string;
    strikeTime: string;
    isQuantityDirty: boolean;
    zeroQuantity: boolean;
};

export function constructRows({
    timeFormat,
    data,
    isQuantityDirty,
    zeroQuantity,
}: {
    timeFormat: TimeFormat;
    data: EstimatedTradeCostComparisonData | undefined;
    isQuantityDirty: boolean;
    zeroQuantity: boolean;
}): EstimatedTradeCostGridRow[] {
    return (data?.requests ?? []).map((i) => {
        const status = i.data?.status;
        const error =
            status === 'Failed' ? extractErrorMessage(i.data) : undefined;

        const ret: EstimatedTradeCostGridRow = {
            benchmark: i.config.benchmark ?? '',
            profile: i.config.profile ?? '',
            maxPartLit: i.config.maxPartLit ?? 0,
            strikeTime:
                i.config.benchmark === StrikeBenchmark
                    ? strikeTimeToString(i.config.strikeTime)
                    : 'N/A',
            minPartLit: i.config.minPartLit ?? 0,
            uid: i.uid,
            status: status ?? 'In Progress',
            error,
            isQuantityDirty,
            zeroQuantity,
        };

        if (
            i.data?.response?.results &&
            i.data?.response?.results.length > 0 &&
            !isQuantityDirty &&
            !zeroQuantity
        ) {
            const summary = i.data?.response?.results[0]?.summary;
            if (summary) {
                ret.totalCost = summary.bm_cost;
                ret.totalRisk = summary.current_risk;
                ret.startTime = formatResponseTime(
                    timeFormat,
                    i.data?.response?.results[0]?.summary?.intv_eff_commence
                );
                ret.endTime = formatResponseTime(
                    timeFormat,
                    i.data?.response?.results[0]?.summary?.intv_eff_complete
                );
                ret.efPart = (summary.intv_eff_pov2 ?? 0) * 100;
            }
        }

        return ret;
    });
}
